import styled from "styled-components";

export const Wrapper = styled.div`
  background: #11112f;
  padding: 15px 5% 42px;
  text-align: right;
  color: white;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: bold;
  font-size: 1rem;
  position: relative;

  @media (max-width: 500px) {
    font-size: 12px;
  }
  font-family: "poppinsBold";

  .footer__text {
    padding-right: 10px;
  }
  .footer__logo {
    img {
      width: 8vw;
      max-width: 50px;
      min-width: 45px;
    }
  }
`;
